import { createI18n } from 'vue-i18n'
import messages from './locales/messages.json'
/*import zhCn from './locales/zh-CN.json'
import enUs from './locales/en-US.json'

const messages = {
  'zh-CN': zhCn,
  'en-US': enUs
}*/

export default createI18n({
  locale: 'en-US', // 默认语言
  fallbackLocale: 'zh-CN', // 备选语言
  legacy: true,
  allowComposition: true,
  messages: messages
})